import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "js-step-3" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "o-grid u-mar-t-1" }
const _hoisted_4 = { class: "o-grid__cell o-grid__cell--4-1024 o-grid__cell--12-360" }
const _hoisted_5 = {
  key: 0,
  class: "u-form-heading"
}
const _hoisted_6 = {
  key: 1,
  class: "u-form-heading"
}
const _hoisted_7 = ["required", "aria-required"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["required", "aria-required"]
const _hoisted_10 = ["required", "aria-required"]
const _hoisted_11 = ["required", "aria-required"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Steps = _resolveComponent("Steps")!
  const _component_antragsteller = _resolveComponent("antragsteller")!
  const _component_vertragsunterlagen_digital = _resolveComponent("vertragsunterlagen-digital")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_zahlungsdaten = _resolveComponent("zahlungsdaten")!
  const _component_vorversicherung = _resolveComponent("vorversicherung")!
  const _component_vorschaeden = _resolveComponent("vorschaeden")!
  const _component_hug_mitgliedschaft = _resolveComponent("hug-mitgliedschaft")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Steps, {
      items: _ctx.navItems,
      active: 2,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_antragsteller, {
        ref: "antragstellerRef",
        fehler: _ctx.fehler
      }, null, 8, ["fehler"]),
      _createVNode(_component_vertragsunterlagen_digital, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      (_ctx.hatMitversichertePerson())
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (!_ctx.piniaStore.state.isMakler)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_5, "Mitversicherter Lebenspartner"))
                  : (_openBlock(), _createElementBlock("h2", _hoisted_6, "Mitversicherte Person"))
              ])
            ]),
            _createVNode(_component_zeile, null, {
              default: _withCtx(() => [
                _createVNode(_component_titel_zelle, null, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("Art der Partnerschaft")
                  ])),
                  _: 1,
                  __: [7]
                }),
                _createVNode(_component_zelle, null, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("select", {
                      id: "typeOfPartnership",
                      name: "typeOfPartnership",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.personendaten.mitversichertePerson.artDerPartnerschaft) = $event)),
                      "data-cy": "artDerPartnerschaft",
                      class: "c-form-control-select",
                      required: _ctx.hatMitversichertePerson(),
                      "aria-required": _ctx.hatMitversichertePerson(),
                      "aria-label": "Art der Partnerschaft"
                    }, _cache[8] || (_cache[8] = [
                      _createElementVNode("option", {
                        selected: "",
                        value: "0"
                      }, "Bitte wählen", -1),
                      _createElementVNode("option", { value: "1" }, "Ehe/eingetragene Lebenspartnerschaft", -1),
                      _createElementVNode("option", { value: "2" }, "Häusliche Gemeinschaft", -1)
                    ]), 8, _hoisted_7), [
                      [
                        _vModelSelect,
                        _ctx.piniaStore.state.personendaten.mitversichertePerson.artDerPartnerschaft,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createVNode(_component_validierungs_fehler, {
                      "fehler-text": _ctx.fehler.typeOfPartnership,
                      "reduzierter-abstand": true
                    }, null, 8, ["fehler-text"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.isHaeuslicheGemeinschaft)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_zeile, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_titel_zelle, null, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode("Vorname und Name")
                        ])),
                        _: 1,
                        __: [9]
                      }),
                      _createVNode(_component_zelle, { breite: 3 }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "partnerFirstname",
                            name: "partnerFirstname",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.personendaten.mitversichertePerson.vorname) = $event)),
                            "data-cy": "partnerVorname",
                            class: "c-form-control__input",
                            placeholder: "Vorname",
                            minlength: "2",
                            maxlength: "40",
                            required: _ctx.isHaeuslicheGemeinschaft,
                            "aria-required": _ctx.isHaeuslicheGemeinschaft,
                            "aria-label": "Vorname des Partners",
                            "data-fehlermeldung": "Bitte geben den Vornamen ein (2-40 Zeichen)."
                          }, null, 8, _hoisted_9), [
                            [
                              _vModelText,
                              _ctx.piniaStore.state.personendaten.mitversichertePerson.vorname,
                              void 0,
                              {
                                lazy: true,
                                trim: true
                              }
                            ]
                          ]),
                          _createVNode(_component_validierungs_fehler, {
                            "fehler-text": _ctx.fehler.partnerFirstname
                          }, null, 8, ["fehler-text"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_zelle, { breite: 3 }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "partnerLastname",
                            name: "partnerLastname",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.personendaten.mitversichertePerson.nachname) = $event)),
                            "data-cy": "partnerNachname",
                            class: "c-form-control__input",
                            placeholder: "Name",
                            minlength: "2",
                            maxlength: "40",
                            required: _ctx.isHaeuslicheGemeinschaft,
                            "aria-required": _ctx.isHaeuslicheGemeinschaft,
                            "aria-label": "Nachname des Partners",
                            "data-parsley-combined-name-length": "40",
                            "data-fehlermeldung": "Bitte geben den Nachnamen ein (2-40 Zeichen)."
                          }, null, 8, _hoisted_10), [
                            [
                              _vModelText,
                              _ctx.piniaStore.state.personendaten.mitversichertePerson.nachname,
                              void 0,
                              {
                                lazy: true,
                                trim: true
                              }
                            ]
                          ]),
                          _createVNode(_component_validierungs_fehler, {
                            "fehler-text": _ctx.fehler.partnerLastname
                          }, null, 8, ["fehler-text"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_zeile, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_titel_zelle, null, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode("Geburtsdatum")
                        ])),
                        _: 1,
                        __: [10]
                      }),
                      _createVNode(_component_zelle, { breite: 3 }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            id: "partnerBirthdate",
                            name: "partnerBirthdate",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.personendaten.mitversichertePerson.geburtsdatum) = $event)),
                            "data-cy": "partnerGeburtsdatum",
                            class: "c-form-control__input",
                            placeholder: "TT.MM.JJJJ",
                            title: "Geburtsdatum im Format TT.MM.JJJJ",
                            minlength: "10",
                            maxlength: "10",
                            pattern: "[0-9]{2}.[0-9]{2}.[0-9]{4}",
                            required: _ctx.isHaeuslicheGemeinschaft,
                            "aria-required": _ctx.isHaeuslicheGemeinschaft,
                            "aria-label": "Geben Sie das Geburtsdatum im Format TT.MM.JJJJ ein",
                            "data-checkalter18bis100": "true"
                          }, null, 8, _hoisted_11), [
                            [
                              _vModelText,
                              _ctx.piniaStore.state.personendaten.mitversichertePerson.geburtsdatum,
                              void 0,
                              {
                                lazy: true,
                                trim: true
                              }
                            ]
                          ]),
                          _createVNode(_component_validierungs_fehler, {
                            "fehler-text": _ctx.fehler.partnerBirthdate
                          }, null, 8, ["fehler-text"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_zahlungsdaten, {
        ref: "zahlungsdatenRef",
        fehler: _ctx.fehler
      }, null, 8, ["fehler"]),
      _createVNode(_component_vorversicherung, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      _createVNode(_component_vorschaeden, {
        fehler: _ctx.fehler,
        "zeige-schadenart": _ctx.piniaStore.state.tarifinformationen.hundehalterhaftpflicht
      }, null, 8, ["fehler", "zeige-schadenart"]),
      (_ctx.zeigeFrageHugNachlass)
        ? (_openBlock(), _createBlock(_component_hug_mitgliedschaft, {
            key: 1,
            fehler: _ctx.fehler
          }, null, 8, ["fehler"]))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_zelle, {
            offset: 4,
            breite: 4
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "c-button c-button--full-width u-mar-t-2 u-mar-b-2 mobil-mehrAbstand",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.nextPage())),
                "data-cy": "submitIhreDaten"
              }, " Zusammenfassung und Abschluss ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.istSichtbar('modalBeitragsaenderung'))
      ? (_openBlock(), _createBlock(_component_modal, _mergeProps({ key: 0 }, _ctx.modalBeitragsaenderung, {
          onCloseModal: _cache[6] || (_cache[6] = ($event: any) => (_ctx.wechsleSichtbarkeit('modalBeitragsaenderung')))
        }), null, 16))
      : _createCommentVNode("", true)
  ], 64))
}